import GridTile from "../grid/GridTile";
import Color from "../color/Color";
import ColoredShadowCastCallback from "./ColoredShadowCastCallback";

export default class PositionalLightSourceCastCallback extends ColoredShadowCastCallback {
    /**
     * @param {Color} lightColor 
     * @param {number} lightSourceCastRadius  
     */
    constructor(lightColor, lightSourceCastRadius ) {
        super(lightColor, lightSourceCastRadius );
    }

    /**
     * @override
     * @param {GridTile} tile 
     * @param {number} radius 
     * @param {number} lightFraction 
     */
    tileLighted(tile, radius, lightFraction) {
        //////tile.lighting.addPositionalLighting(this.calculatedLightedColor(radius, lightFraction));
        tile.addPositionalLighting(this.calculatedLightedColor(radius, lightFraction));
    }
}
